/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum CloudProductTypes {
    Aws = 'aws',
    Azure = 'azure',
    Google = 'gcp',
}
